export default "__VITE_ASSET__CKay2SSZ__"